import {DiaryEditor as DiaryEditorComponent} from '@dv5/components'
import {FC} from 'react'

interface Props {
    partId: string
    content: string
    setContent: (content: string) => void
}

export const DiaryEditor: FC<Props> = ({partId, content, setContent}) => {
    return <DiaryEditorComponent content={content} setContent={setContent} partId={partId} />
}
